import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import { withStyles } from '@material-ui/core/styles';
import FormControlLabel from '@material-ui/core/FormControlLabel';
import Switch from '@material-ui/core/Switch';

const styles = (theme) => ({
  columnContainer: {
    display: 'flex',
    flexDirection: 'column-reverse',
    alignItems: 'flex-start',
  },
  labelPlacementStart: {
    marginLeft: 0,
  },
  bootstrapFormLabel: {
    fontSize: 12,
    fontWeight: 300,
    color: theme.palette.grey[700],
  },
});

class CustomSwitch extends PureComponent {
  render() {
    const {
      classes,
      label,
      noMargin,
      labelPlacement,
      hasError,
      helpText,
      inline,
      column,
      ...otherProps
    } = this.props;
    return (
      <FormControlLabel
        disableRipple
        labelPlacement={labelPlacement}
        classes={{
          label: classes.bootstrapFormLabel,
          labelPlacementStart: classes.labelPlacementStart,
        }}
        control={
          <Switch
            color="default"
            {...otherProps}
          />
        }
        label={label}
      />
    );
  }
}

CustomSwitch.propTypes = {
  classes: PropTypes.object.isRequired,
};

CustomSwitch.defaultProps = {};

export default withStyles(styles)(CustomSwitch);
